<template>
  <button
    type="button"
    class="group relative flex items-center justify-center size-11 cursor-pointer"
    :aria-label="$t('Shopping cart')">
    <IcOutlineShoppingCart
      class="size-6 text-foreground transition-transform duration-300 ease-[cubic-bezier(0.2,0,0,1)] group-hover:scale-110" />
    <Transition
      enter-active-class="transition duration-300 ease-[cubic-bezier(0.2,0,0,1)]"
      enter-from-class="scale-0 opacity-0"
      leave-active-class="transition duration-200 ease-in"
      leave-to-class="scale-0 opacity-0">
      <span
        v-if="count"
        :key="count"
        class="absolute top-0 right-0 min-w-5 h-5 px-1 flex items-center justify-center rounded-full bg-primary text-foreground font-bold leading-none"
        style="font-size: 12px">
        {{ count }}
      </span>
    </Transition>
  </button>
</template>

<script setup>
import IcOutlineShoppingCart from "~icons/ic/outline-shopping-cart";

defineProps({
  count: { required: true },
  items: { required: true },
});
</script>
